export enum EAuthUrls {
  AUTH = 'auth',
  RESEND_PASSWORD = 'resend-password',
}
